// @flow
/* ***************************************************************************
* @author mfranco (mfranco@mobinteg.com)
*******************************************************************************/

import React, { Component } from "react"
import style from "./style.css"
import Checkbox from "react-toolbox/lib/checkbox"
import { connect } from "react-redux"
import Division from "../../../components/Division"
import * as strings from "../../../strings"
import _ from "lodash"

class CreatePaymentUserAgreement extends Component {
  props: {
    auth: any,
    searchValue: any,
    paymentAgreementState: any,
    onChange: any,
  }

  selectAll = ( preLitigationProcedures, litigationProcedures, initialState ) => {
    let newCheckBoxes = {}

    if ( !this.props.paymentAgreementState.isAllCheckBoxesSelected ) {

      preLitigationProcedures.forEach( ( preLitigationProcedure, i ) => {
        newCheckBoxes[ strings.processes.preLitigationProcedureTag + i ] = preLitigationProcedure.id
      } )

      litigationProcedures.forEach( ( litigationProcedure, i ) => {
        newCheckBoxes[ strings.processes.litigationProcedureTag + i ] = litigationProcedure.id
      } )
    }

    return this.props.onChange( {
      checkBoxes: newCheckBoxes,
      isAllCheckBoxesSelected: !this.props.paymentAgreementState.isAllCheckBoxesSelected,
      ...initialState,
    } )
  }

  selectOne = ( value, isPreLitigation, i, id, preLitigationProcedures, litigationProcedures, initialState ) => {
    const { paymentAgreementState } = this.props
    const increment = paymentAgreementState.isAllCheckBoxesSelected ? -1 : value ? 1 : 0
    let isAllSelected = false

    const checkBoxName = isPreLitigation
      ? strings.processes.preLitigationProcedureTag
      : strings.processes.litigationProcedureTag

    if ( paymentAgreementState.checkBoxes[ id ] ) {
      isAllSelected = preLitigationProcedures.length + litigationProcedures.length === _.compact(
        Object.values( paymentAgreementState.checkBoxes ) ).length + increment ? true : false
    }

    this.props.onChange( {
      checkBoxes: {
        ...paymentAgreementState.checkBoxes,
        [ checkBoxName + i ]: paymentAgreementState.checkBoxes[ checkBoxName + i ] ? undefined : id,
      },
      isAllCheckBoxesSelected: isAllSelected,
      ...initialState,
    } )

  }

  render () {
    const { searchValue, paymentAgreementState } = this.props
    const { generalStrings } = strings
    let debtDebtor
    let preLitigationProcedures = []
    let litigationProcedures = []

    if ( this.props.searchValue.length !== 0 ) {
      debtDebtor = searchValue.debtDebtors.find(
        debtDebtor => debtDebtor.idDebtor === paymentAgreementState.debtorChecked
      )

      preLitigationProcedures = searchValue.preLitigations.map( preLitigation => preLitigation )
      litigationProcedures = searchValue.litigations.map( litigation => litigation )
    }

    const debtorName = _.get( debtDebtor, "debtor.contact.name", generalStrings.emptyField )

    const initialState = {
      debtValue: 0,
      capitalValue: 0,
      numberOfPayments: undefined,
      valuePerPayment: undefined,
      firstPaymentDate: new Date(),
      paymentDates: {},
      payments: {},
      isChangedPayment: {},
      interestValue: 0,
      newInvoices: [],
      justiceTax: undefined,
      interestRate: 0,
      arePaymentInputsValid: [ false, false ],
      isClientValid: false,
      idInterestType: 0,
      taxValue: undefined,
    }

    return (
      <div className={style.createPaymentAgreementBackGround}>
        <div className={style.columnInfo}>
          <Division title={ strings.processes.processesOf + debtorName }/>
          <div className={style.firstBetweenDivisors}>
          </div>
          <div className={style.showContent}>
            <div className={style.betweenDivisors}>
              <div className={style.procs}>
                <table className={style.tableCss}>
                  <thead>
                    <tr className={style.tablePadding}>
                      <th className={style.checkBoxFix}>
                        <Checkbox
                          checked={this.props.paymentAgreementState.isAllCheckBoxesSelected}
                          onChange={() => this.selectAll( preLitigationProcedures, litigationProcedures, initialState )}
                        />
                      </th>
                      <th className={style.tableTitle}><b>{strings.generalStrings.idc}</b></th>
                      <th className={style.tableTitle}><b>{strings.generalStrings.type}</b></th>
                      <th className={style.tableTitle}><b>{strings.generalStrings.subType}</b></th>
                      <th className={style.tableTitle}><b>{strings.generalStrings.state}</b></th>
                    </tr>
                  </thead>
                  <tbody>
                    {preLitigationProcedures.map( ( preLitigationProcedure, i ) => {
                      const subType = _.get( preLitigationProcedure, "activeOption.subtype.name" )
                      const type = _.get( preLitigationProcedure, "activeOption.type.name" )
                      const state = _.get( preLitigationProcedure, "activeOption.state.name" )
                      return (
                        <tr key={i}>
                          <td className={style.checkBoxFix}>
                            <Checkbox
                              checked={this.props.paymentAgreementState.checkBoxes[
                                strings.processes.preLitigationProcedureTag + i
                              ]}
                              onChange={( value ) => this.selectOne(
                                value,
                                true,
                                i,
                                preLitigationProcedure.id,
                                preLitigationProcedures,
                                litigationProcedures,
                                initialState
                              )}
                            />
                          </td>
                          <td>{preLitigationProcedure.idc || generalStrings.emptyField}</td>
                          <td>{type || generalStrings.emptyField}</td>
                          <td>{subType || generalStrings.emptyField}</td>
                          <td>{state || generalStrings.emptyField}</td>
                        </tr>
                      )
                    } ) }
                    {litigationProcedures.map( ( litigationProcedure, i ) => {
                      const subType = _.get( litigationProcedure, "activeOption.subtype.name" )
                      const type = _.get( litigationProcedure, "activeOption.type.name" )
                      const state = _.get( litigationProcedure, "activeOption.state.name" )

                      return (
                        <tr key={i}>
                          <td className={style.checkBoxFix}>
                            <Checkbox
                              checked={this.props.paymentAgreementState.checkBoxes[
                                strings.processes.litigationProcedureTag + i
                              ]}
                              onChange={( value ) => this.selectOne(
                                value,
                                false,
                                i,
                                litigationProcedure.id,
                                preLitigationProcedures,
                                litigationProcedures,
                                initialState
                              )}
                            />
                          </td>
                          <td>{litigationProcedure.idc || generalStrings.emptyField}</td>
                          <td>{type || generalStrings.emptyField}</td>
                          <td>{subType || generalStrings.emptyField}</td>
                          <td>{state || generalStrings.emptyField}</td>
                        </tr>
                      )
                    } ) }
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ( store ) => {
  return {
    auth: store.auth,
  }
}

export default connect( mapStateToProps, { } )( CreatePaymentUserAgreement )



// WEBPACK FOOTER //
// ./src/views/CreatePaymentAgreementPage/CreatePaymentUserAgreement/index.jsx